"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            submitting: false,
            SSToken: null
        };
        GState.bind(this, [
            'tenant',
            'auth'
        ]);
        fhandler.bind(this, this.state.auth && this.state.auth.formdata || {});
    },
    onInput: function (input) {
        input.params.errmess && fhandler.alert(input.params.errmess);
    },
    onMount: async function () {
        let location;
        try {
            location = await getClientLocation();
        } catch (error) {
            console.log('Get Client Location Error: ', error);
            throw new Error('We are having trouble getting your location. Try again');
        }
        fhandler.set('country', location);
        UISocket.emit('APP::GET_SSOTOKEN', {
            authType: 'signin',
            device: window.Device,
            userAgent: window.UserAgent,
            location
        }, token => this.state.SSToken = token);
    },
    onSubmit: async function (e) {
        if (this.state.submitting)
            return;
        const Form = this.state.form;
        if (!Form.email)
            return fhandler.error('email', 'Email Address field is required');
        if (!Form.password)
            return fhandler.error('password', 'Password field is required');
        if (isDefaultDomain())
            Form.role = 'OWNER';
        Form.device = window.Device;
        const factor = window.uiStore.get('2FA-Factor');
        if (factor && factor.ignore)
            Form.ignore2FA = true;
        this.state.submitting = true;
        try {
            const {error, message, credentials, twoStep, next} = await AuthRequest('/signin', 'POST', Form);
            this.state.submitting = false;
            fhandler.alert(message, error ? 'info' : 'success');
            if (error)
                return;
            switch (next) {
            case 'grantaccess': {
                    twoStep ? this.twoStepAccess(twoStep, credentials) : this.grantAccess(credentials);
                }
                break;
            case 'two-step':
                this.twoStepAccess(twoStep, credentials);
                break;
            default: {
                    window.uiStore.set('email', Form.email);
                    navigate('/' + (next || 'signin'));
                }
            }
            !error && fhandler.reset();
        } catch (error) {
            this.state.submitting = false;
            fhandler.alert(error, 'warning');
        }
    },
    createQueries: function (credentials) {
        let queries = Obj2Params(credentials);
        if (isDefaultDomain())
            queries += '&redirectTo=/onboarding';
        else {
            if (this.input.params.hasOwnProperty('redirectTo'))
                queries += '&redirectTo=' + encodeURIComponent(this.input.params.redirectTo);
        }
        return queries;
    },
    twoStepAccess: function (action, credentials) {
        if (typeof action == 'object') {
            window.uiStore.set('2FA-Factor', action.factor);
            navigate(`/two-step/verify?mtd=code&vtoken=${ action.token }`);
            return;
        }
        navigate(`/two-step?pros=${ action }&mstrict=true&2fa_agent=web&${ this.createQueries(credentials) }`);
    },
    grantAccess: function (credentials) {
        document.location = `/authorize?${ this.createQueries(credentials) }`;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Auth/Signin.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    SSOAuth_template = require("../../components/SSOAuth.marko"),
    SSOAuth_tag = marko_loadTag(SSOAuth_template),
    AuthLayout_template = require("../../components/AuthLayout/index.marko"),
    AuthLayout_tag = marko_loadTag(AuthLayout_template),
    marko_attrs0 = {
        "class": "card-body"
      },
    marko_attrs1 = {
        "class": "mx-50"
      },
    marko_attrs2 = {
        "class": "mt-0"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("dd39d7"),
    marko_node0 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_attrs5 = {
        "class": "py-1"
      },
    marko_node2 = marko_createElement("br", null, "24", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs6 = {
        "class": "font-medium-1 mx-50 mt-4"
      },
    marko_attrs7 = {
        "class": "card-header w-100 text-center pb-0"
      },
    marko_node3 = marko_createElement("br", null, "2", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "3", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("p", {
        "class": "mt-4 font-small"
      }, "13", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Invalid Email Address"),
    marko_node6 = marko_createElement("p", {
        "class": "mt-4 font-small"
      }, "16", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Invalid Password");

const fhandler = new FormHandler({ key: 'signin-form' });

function render(input, out, __component, component, state) {
  var data = input;

  AuthLayout_tag({
      showLogo: true,
      renderBody: function(out) {
        if (state.auth && state.auth.message) {
          out.e("div", marko_attrs7, "1", component, 3)
            .n(marko_node3, component)
            .n(marko_node4, component)
            .e("p", null, "4", component, 1)
              .t(state.auth.message, component);
        }

        out.be("div", marko_attrs0, "5", component);

        FormAlert_tag({
            alert: state.alert,
            class: "mx-50"
          }, out, __component, "6");

        out.be("form", marko_attrs1, "@signin-form", component);

        out.be("h5", marko_attrs2, "7", component);

        Locale_tag({
            text: "Sign In"
          }, out, __component, "8");

        out.ee();

        out.n(marko_node0, component);

        out.n(marko_node1, component);

        out.be("div", marko_attrs3, "11", component);

        out.e("input", {
            "class": "form-control form-control-xl",
            type: "email",
            required: true,
            name: "email",
            value: state.form.email,
            validate: fhandler.define("email"),
            placeholder: Locale("Email Address")
          }, "12", component, 0, 0, {
            onchange: __component.d("change", "__onChange", false)
          });

        if (state.formError.email) {
          out.n(marko_node5, component);
        }

        out.ee();

        out.be("div", marko_attrs4, "14", component);

        out.e("input", {
            "class": "form-control form-control-xl",
            type: "password",
            required: true,
            name: "password",
            value: state.form.password,
            placeholder: Locale("Password")
          }, "15", component, 0, 0, {
            onchange: __component.d("change", "__onChange", false)
          });

        if (state.formError.password) {
          out.n(marko_node6, component);
        }

        out.ee();

        out.be("button", {
            type: "submit",
            disabled: state.submitting,
            "class": "btn btn-primary btn-xl text-left w-100"
          }, "17", component, null, 0, {
            onclick: __component.d("click", "onSubmit", false)
          });

        if (state.submitting) {
          Preloader_tag({
              class: "float-right font-medium-5",
              active: true
            }, out, __component, "18");
        } else {
          Bx_tag({
              type: "right-arrow-alt",
              class: "font-large-1 float-right white-text"
            }, out, __component, "19");
        }

        Locale_tag({
            text: "Sign In"
          }, out, __component, "20");

        out.ee();

        out.be("div", marko_attrs5, "21", component);

        route_link_tag({
            href: "/forgotten-pwd" + (state.form.email ? "?email=" + state.form.email : ""),
            class: "float-right",
            renderBody: function(out) {
              Locale_tag({
                  text: "Forgotten Password"
                }, out, __component, "23");
            }
          }, out, __component, "22");

        out.ee();

        out.ee();

        out.n(marko_node2, component);

        SSOAuth_tag({
            token: state.SSToken
          }, out, __component, "25");

        out.be("div", marko_attrs6, "26", component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Don't have an account?");
            }
          }, out, __component, "27");

        out.t(" ");

        route_link_tag({
            href: "/signup",
            class: "text-secondary",
            renderBody: function(out) {
              Locale_tag({
                  text: "Sign Up",
                  class: "font-medium-1"
                }, out, __component, "29");
            }
          }, out, __component, "28");

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
